import TitleBlock from '@anm/components/TitleBlock';
import { CardModalWrapper } from '@anm/components/modals/CardModal';
import styled, { createGlobalStyle } from 'styled-components';

export const CardModalStyles = createGlobalStyle`
  ${CardModalWrapper} {
    pointer-events: all;
  }
`;

export const Title = styled(TitleBlock)`
  margin: 10px 0;
  text-align: center;
`;

const Wrapper = styled.div`
  border-radius: 5px;
  padding: 10px 20px;
  margin: -10px -20px;
  pointer-events: auto;
`;

export default Wrapper;
